window.inn = window.inn || {};
window.inn.texts = window.inn.texts || {};
export default {
    'validation.pin': window.inn.texts['validation.pin'] || '',
    'validation.password': window.inn.texts['validation.password'] || '',
    'validation.email': window.inn.texts['validation.email'] || '',
    'validation.streetaddress': window.inn.texts['validation.streetaddress'] || '',
    'validation.zipcode': window.inn.texts['validation.zipcode'] || '',
    'validation.city': window.inn.texts['validation.city'] || '',
    'validation.firstname': window.inn.texts['validation.firstname'] || '',
    'validation.lastname': window.inn.texts['validation.lastname'] || '',
    'validation.phone': window.inn.texts['validation.phone'] || '',
    'validation.empty': window.inn.texts['validation.empty'] || '',
    'validation.name': window.inn.texts['validation.name'] || ''
};
